import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { User } from 'src/app/models/user.model';
import { UserService } from 'src/app/admin/services/user.service';
import { validateEditUser } from 'src/app/utils/formValidators';

@Component({
  selector: 'app-edit-user-modal',
  templateUrl: './edit-user-modal.component.html',
  styleUrls: ['./edit-user-modal.component.scss'],
})
export class EditUserModalComponent implements OnInit {

  user: User;
  errMsg: string = '';
  passwordResetSuccess: boolean = false;
  resetPassword:any;
  reset: any;

paginationSettings = {curentPage: 0};
managers = [];
currentPage: number = 1;
itemsPerPage: number = 20;
usernameQuery: string = '';
firstNameQuery: string = '';
lastNameQuery: string = '';
idCardNoQuery: string = '';
messageError:string=""  

  constructor(private modalController: ModalController, private userService: UserService, private router:Router ) { }

  ngOnInit() {
    this.user.managerId = this.user['manager']?.id;  
  }

  resetUserPassword() {   
   
    this.userService.resetPassword(this.user).subscribe(res => {
      this.passwordResetSuccess = true;
    })
  }

  editUser() {
    const formValidation = validateEditUser(this.user)
    
    this.errMsg = formValidation.errMsg;
   if(formValidation.isValid) {
      this.userService.editUser(this.user).subscribe((res) => {       
       this.loadusers();
       this.dismissModal();
       
      },(err) => {
         if (err.error.errors.includes('username-is-already-registered')) {
          this.messageError = 'Greška: Korisničko ime već postoji u sistemu.';
        }

        else if (err.error.errors.includes('id-card-is-already-registered')) {
          this.messageError = 'Greška: Broj lične karte je već upisan u sistemu.';
        }

        else if (err.error.errors.includes('OperatorId-is-already-exists')) {
          this.messageError = 'Greška: Id operatera već postoji u sistemu.';
        }
       
        this.errMsg = this.messageError      
       
      })
    }  

}

  async openResetPasswordUserModal(resetPassword) {
    this.resetPassword=resetPassword
    this.modalController.dismiss();
    const modal = await this.modalController.create({
      component: EditUserModalComponent,
      componentProps: {user: {...this.user}, resetPassword: true},
      cssClass: 'small-modal-css',
      backdropDismiss: true,
      swipeToClose: false,
    });
    await modal.present();
  }

  dismissModal() {
    this.modalController.dismiss();
  }

  async loadusers() {
    this.userService.getAllUsers({
      currentPage: this.currentPage, itemsPerPage: this.itemsPerPage, usernameQuery: this.usernameQuery,
      firstNameQuery: this.firstNameQuery, lastNameQuery: this.lastNameQuery, idCardNoQuery: this.idCardNoQuery
    });
    this.userService.paginationSettings$.subscribe(pagSettings => {
      this.paginationSettings = pagSettings;
    });

  }


}
